export default {"src":"/_next/static/media/PANW.8d4accc9.svg","height":18,"width":18};